<template>
  <v-layout column>

    <h2>Tratamentos</h2>
    <h3 class="mb-4 text-secondary">Treatments</h3>

    <h2>Em caso de febre, e a escola não conseguindo contatar os pais:</h2>
    <h2 class="mb-4">In case of fever and if we cannot contact the parents:</h2>

    <v-textarea
      outline
      v-model="resource.form.treatment_details"
      label="DESCRIÇÃO DO TRATAMENTO/ TREATMENT DESCRIPTION"
    />

    <v-text-field
      outline
      v-model="resource.form.specialist_name"
      label="NOME DO ESPECIALISTA/ SPECIALIST´S NAME"
    />

    <v-textarea
      outline
      v-model="resource.form.other_information"
      label="OUTRAS INFORMAÇÕES IMPORTANTES/ OTHER IMPORTANT INFORMATION"
    />

  </v-layout>
</template>

<script>
/**
 * @group Form
 * Componente de form para dados de Tratamento do estudante para caso não seja impossível contatar os responsáveis
 */
export default {
  name: 'FormThreatment',

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    }
  }
}
</script>
